import { useTranslation } from 'react-i18next';
import Icons from '../../../../configs/icon.config';

interface DrawerHeaderProps {
  handleClose: any;
}

function DrawerHeader({ handleClose }: DrawerHeaderProps) {
  const { t } = useTranslation();
  return (
    <div className="flex justify-between mb-8">
      <div className="text-[18px]">{t('feedback.title')}</div>
      <button
        onClick={handleClose}
        className="text-[#D10D74] h-[20px] w-[20px] feedback-icon"
      >
        {Icons.cross}
      </button>
    </div>
  );
}

export default DrawerHeader;
